// extracted by mini-css-extract-plugin
export default {"imageContent":"sp-z","modal":"tp-z"};